import { Component, Input, OnInit } from '@angular/core';
import { OccConfig } from '@spartacus/core';

@Component({
    selector: 'app-warranty-documents',
    templateUrl: './warranty-documents.component.html',
    styleUrls: ['./warranty-documents.component.scss'],
    standalone: false
})
export class WarrantyDocumentsComponent implements OnInit {
  ngOnInit(): void {
    this.filteredData = this.warrantyDocs.filter((obj) => Object.keys(obj).length !== 0);
  }
  @Input() warrantyDocs: any;
  filteredData: any;
  baseUrl: String = this.config?.backend?.occ?.baseUrl + '/';
  constructor(private config: OccConfig) {}
}
